import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { LucideModule } from '../../modules/lucide.module';
import { DialogButtonComponent } from '../dialog-button/dialog-button.component';
import { recursosDoModulo } from './recursos-modulos.catalogo';


/**
 * Dados do modal aberto pelo ícone de olho dos cards de módulo.
 * O mesmo formato serve para qualquer hub (home do adm, e-SIC, ouvidoria etc.).
 */
export interface ResumoModuloDados {
  titulo: string;
  descricao: string;
  icone: string;
  /** Linha abaixo do título, dizendo de que hub o módulo faz parte. */
  contexto: string;
  ativo: boolean;
  rota: string | null;
  /**
   * O que o usuário encontra dentro da tela. Quando não vier, o modal busca a
   * lista no catálogo de recursos pela rota do módulo.
   */
  recursos?: string[];
  /** Quantidade de registros já cadastrados, quando o hub acompanha esse número. */
  itens?: number;
  rotuloItens?: string;
  /** Falso quando a tela ainda não foi publicada. */
  disponivel?: boolean;
  rotuloAbrir?: string;
}

export type ResumoModuloResult = 'abrir';

@Component({
  selector: 'app-modulo-resumo',
  standalone: true,
  imports: [CommonModule, LucideModule, MatDialogClose, MatDialogContent, DialogButtonComponent],
  templateUrl: './modulo-resumo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modulo-resumo.component.css'
})
export class ModuloResumoComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<ModuloResumoComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly dados: ResumoModuloDados
  ) { }

  get recursos(): string[] {
    return this.dados.recursos?.length
      ? this.dados.recursos
      : recursosDoModulo(this.dados.rota);
  }

  get emBreve(): boolean {
    return this.dados.disponivel === false || !this.dados.rota;
  }

  get rotuloItens(): string {
    return this.dados.rotuloItens ?? 'Itens cadastrados';
  }

  get rotuloAbrir(): string {
    return this.dados.rotuloAbrir ?? 'Abrir módulo';
  }

  abrir(): void {
    this.dialogRef.close('abrir' as ResumoModuloResult);
  }
}
